import { render, staticRenderFns } from "./ClaimDialog.vue?vue&type=template&id=23373880&scoped=true&"
import script from "./ClaimDialog.vue?vue&type=script&lang=js&"
export * from "./ClaimDialog.vue?vue&type=script&lang=js&"
import style0 from "./ClaimDialog.vue?vue&type=style&index=0&id=23373880&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23373880",
  null
  
)

export default component.exports